import { Route, Switch } from 'react-router-dom';
import BuyingGroupOverview from './buyingGroupOverview';
import CreateBuyingGroup from './createBuyingGroup/createBuyingGroup';
import BuyingGroupDetail from './buyingGroupDetail/buyingGroupDetail';

const BuyingGroupRouter = () => (
  <Switch>
    <Route exact path="/buyinggroup" component={BuyingGroupOverview} />
    <Route exact path="/buyinggroup/create" component={CreateBuyingGroup} />
    <Route exact path="/buyinggroup/:id" component={BuyingGroupDetail} />
  </Switch>
);

export default BuyingGroupRouter;
